import { render } from "./ContactLinks.vue?vue&type=template&id=fdd61694"
const script = {}
script.render = render

export default script